import { FC, useEffect } from "react";
import toast from "react-hot-toast";
import { NavLink, useNavigate } from "react-router-dom";
import { getErrorFromCatch } from "../../api/api";
import { vendorApi } from "../../api/vendor.api";
import { useAccess } from "../../hooks/useAccess";
import { msg } from "../../msg";
import Truncate from "../common/Truncate";
import Table, { ITableTh } from "../common/table/Table";
import VendorActionMenu from "./VendorActionMenu";

const VendorList: FC = () => {
  const navigate = useNavigate();
  const { getSettingAccess } = useAccess();

  // -- Load vendor list
  const { data: vendors, isFetching, isError, error } = vendorApi.useGetVendorListQuery();

  // -- Table header
  const thead: ITableTh[] = [
    { title: 'Name' },
    { title: 'Agent Name' },
    { title: 'Agent Phone' },
    { title: 'Orders Notification Email' },
    { title: 'External Key' },
    { title: 'QBO Returns Account' },
    { title: '' },
  ];

  // -- Api Error handler
  useEffect(() => {
    isError && error && toast.error(`${msg('vendor-list')} ${getErrorFromCatch(error)}`);
  }, [isError]);

  return (
    <Table
      size="small"
      options={!getSettingAccess('add-vendor') ? [] : [
        <NavLink
          to="/vendors/new"
          className="inline-block rounded-lg bg-primary text-white px-4 py-2 text-sm [text-shadow:_0_1px_2px_rgb(0_0_0/_0.5)]"
        >
          Add Vendor
        </NavLink>,
      ]}
      isPending={isFetching}
      thead={thead}
      tbody={!vendors?.length
        ? undefined
        : vendors.map(({ id, name, agentName, agentPhone, agentEmail, externalKey, qboReturnsAccount }) => ({
          onClick: () => navigate(`/vendors/${id}`),
          data: [
            <NavLink to={`/vendors/${id}`}>{name}</NavLink>,

            <Truncate title={agentName}>
              {agentName || ' '}
            </Truncate>,

            <Truncate title={agentPhone}>
              {agentPhone || ' '}
            </Truncate>,

            <Truncate title={agentEmail}>
              {agentEmail || ' '}
            </Truncate>,

            <Truncate title={externalKey}>
              {externalKey || ' '}
            </Truncate>,

            <Truncate title={qboReturnsAccount}>
              {qboReturnsAccount || ' '}
            </Truncate>,

            <VendorActionMenu vendorId={id} vendorName={name} />,
          ]
        }))
      }
    />
  );
};

export default VendorList;
